import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import LabelWithErrors from 'components/common/LabelWithErrors/LabelWithErrors';
import TextField from 'components/common/TextField/TextField';
import fieldErrorParser from 'utils/fieldErrorParser';

import style from './PromoCode.module.scss';

interface iProps {
  updateCupon: (val: string) => void;
}
export default ({ updateCupon }: iProps) => {
  const { t } = useTranslation();
  const [showInput, setShowInput] = useState<boolean>(false);
  return (
    <div className={style.container}>
      {!showInput && <div onClick={() => setShowInput(val => !val)}>{t('login:gotPromoCode')}</div>}
      {showInput && (
        <div>
          <LabelWithErrors
            labelAndValidation={{
              label: t('login:couponCode'),
            }}
            errorInfo={fieldErrorParser()}
          />
          <TextField onChange={e => updateCupon(e.target.value)} />
        </div>
      )}
    </div>
  );
};
